import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerService } from '@shared/services/spinner.service';

@Component({
  selector: 'app-spinner-manual',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent {
  isLoading = this.spinnerSvc.isLoading;
  constructor(private spinnerSvc: SpinnerService) {}
}
